import { Navigate } from "react-router-dom";

export function WalletsRedirect() {
	return <Navigate to="/wallets/outbound" replace />;
}
